<template>
    <ElementLayout :parent="parent" :element="element">
        <div style="display:flex">
            <v-text-field v-model="element.value" @change="fieldChanged" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
            <div>
                <v-btn @click="increment(-1)" fab small class="primary" style="margin:5px 3px 0px 0px">-</v-btn>
                <v-btn @click="increment(1)" fab small class="primary" style="margin:5px 6px 0px 0px">+</v-btn>
            </div>
        </div>
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 

export default {
    data() {
        return {
            // value: null,
            // originalValue: null,
        }
    },

    components: {
        ElementLayout,
    },
    
    props: {
        element: Object,
        parent: Object,
        decimals: Number,
    },

    computed: {

    },

    methods: {
        fieldChanged(newVal) {
            this.$emit('change', newVal, this.originalValue)
            this.originalValue = newVal
        },
        increment(amount) {
            let existingAmount = parseInt(this.element.value)
            this.element.value = existingAmount + amount
        }
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// NumberControl.vue?e7464b3c